module.exports = __webpack_public_path__ + "img/组437@2x.d51c5b5a.png";